import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Регистрация компонентов
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Данные о животных
const dataSource = [
  {
    key: 1,
    animal: "Птицы",
    count: 6368695,
  },
  {
    key: 2,
    animal: "КРС",
    count: 1783469,
  },
  {
    key: 3,
    animal: "Коровы",
    count: 885673,
  },
  {
    key: 4,
    animal: "Лошади",
    count: 533979,
  },
  {
    key: 5,
    animal: "Овцы и Козы",
    count: 6200961,
  },
  {
    key: 6,
    animal: "Свиньи",
    count: 25640,
  },
];

const KRCandMRCChart = () => {
  // Подготовка данных для графика
  const labels = dataSource.map(item => item.animal);
  const counts = dataSource.map(item => item.count);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Количество животных',
        data: counts,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
<div style={{
  width: "100%",
  height: 400,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
}}>
      <h2>Количество КРС и МРС по республике</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default KRCandMRCChart;
